import styled from 'styled-components';

import { Button } from '@catalyze/ui';

export const StyledFormButton = styled(Button)`
    width: 100%;
`;
